// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_threaded_collar/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_threaded_collar: ModuleSchema = {
  "id": "core_threaded_collar",
  "uniqueId": "B3D_TCOL1",
  "createdAt": "2026-10-20T13:16:23.310Z",
  "updatedAt": "2026-10-21T12:06:23.205Z",
  "label": "Threaded Collar",
  "description": "Reusable raised male/female screw collars with one synchronized thread specification.",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "thread",
    "collar",
    "CG_TCOL01"
  ],
  "sliders": [
    {
      "key": "nominalDiameter",
      "label": "Nominal Diameter",
      "min": 20,
      "max": 160,
      "step": 1,
      "default": 60,
      "unit": "mm"
    },
    {
      "key": "threadLength",
      "label": "Thread Length",
      "min": 3,
      "max": 40,
      "step": 1,
      "default": 10,
      "unit": "mm"
    },
    {
      "key": "pitch",
      "label": "Thread Pitch (fixed 4mm)",
      "min": 4,
      "max": 4,
      "step": 1,
      "default": 4,
      "unit": "mm",
      "enabled": false,
      "visible": false
    },
    {
      "key": "threadDepth",
      "label": "Thread Form Depth (fixed 1mm)",
      "min": 1,
      "max": 1,
      "step": 1,
      "default": 1,
      "unit": "mm",
      "enabled": false,
      "visible": false
    },
    {
      "key": "clearance",
      "label": "Radial Clearance (fixed 0.4mm)",
      "min": 0.4,
      "max": 0.4,
      "step": 0.1,
      "default": 0.4,
      "unit": "mm",
      "enabled": false,
      "visible": false
    },
    {
      "key": "wall",
      "label": "Collar Wall",
      "min": 1,
      "max": 12,
      "step": 0.5,
      "default": 4,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "male_collar",
      "label": "Male Collar",
      "default": "#64748b",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "female_collar",
      "label": "Female Collar",
      "default": "#64748b",
      "targetGroupIds": [
        1
      ]
    }
  ],
  "objects": [
    {
      "id": "threaded_collar_pair",
      "label": "Threaded Collar Pair",
      "name": "Threaded Collar Pair",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "male_collar",
          "label": "Male Collar",
          "name": "Male Collar",
          "groupId": 0,
          "colorKey": "male_collar",
          "defaultColor": "#64748b",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        },
        {
          "id": "female_collar",
          "label": "Female Collar",
          "name": "Female Collar",
          "groupId": 1,
          "colorKey": "female_collar",
          "defaultColor": "#64748b",
          "assembled_z_offset": 0,
          "exploded_z_offset": 32,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Collar Pair",
      "groupId": -1
    },
    {
      "id": "male",
      "label": "Download STL - Male Collar",
      "groupId": 0
    },
    {
      "id": "female",
      "label": "Download STL - Female Collar",
      "groupId": 1
    }
  ]
};
